import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=4b76736f&scoped=true&"
import script from "./ProjectImage.vue?vue&type=script&lang=js&"
export * from "./ProjectImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImage.vue?vue&type=style&index=0&id=4b76736f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76736f",
  null
  
)

export default component.exports